<template>
	<a-card :bordered="false">
		<a-spin :spinning="loading">
			<a-form-model
				v-if="!loading && configList.length"
				:key="formKey"
				ref="adminForm"
				:model="formModel"
				:label-col="{ span: 6 }"
				:wrapper-col="{ span: 18 }"
				autoComplete="off"
			>
				<div class="part-box">
					<a-form-model-item
						v-for="item in configList"
						:key="item.id"
						:label="fieldDisplayName(item)"
						:prop="fieldKey(item.ident)"
						:rules="rulesFor(item)"
					>
						<a-radio-group
							v-if="isSwitchIdent(item.ident)"
							v-model="formModel[fieldKey(item.ident)]"
						>
							<a-radio
								v-for="opt in switchRadioOptions(item)"
								:key="opt.value"
								:value="opt.value"
							>{{ opt.label }}</a-radio>
						</a-radio-group>
						<a-input
							v-else
							v-model="formModel[fieldKey(item.ident)]"
							style="width: 300px"
							:prefix="item.inputType === 'price' ? '￥' : undefined"
						/>
						<p v-if="item.depict" class="depict">{{ item.depict }}</p>
					</a-form-model-item>
				</div>
				<a-form-model-item :wrapperCol="{ span: 18, offset: 6 }">
					<a-button
						v-has="'/system/config'"
						type="primary"
						style="height: 36px; width: 140px; font-size: 15px;"
						@click="handleSubmit"
					>提交</a-button>
				</a-form-model-item>
			</a-form-model>
			<a-empty v-else-if="!loading && !configList.length" description="暂无配置项" />
		</a-spin>
	</a-card>
</template>

<script>
	import { configList, configUpdate } from "@/api/system/config";

	export default {
		data() {
			return {
				formModel: {},
				loading: false,
				configList: [],
				formKey: 0
			};
		},
		created() {
			this.fetchData();
		},
		methods: {
			fieldDisplayName(item) {
				if (item.name !== undefined && item.name !== null && String(item.name).trim() !== "") {
					return String(item.name).trim();
				}
				if (item.label !== undefined && item.label !== null && String(item.label).trim() !== "") {
					return String(item.label).trim();
				}
				return item.ident || "";
			},
			fieldKey(ident) {
				if (!ident || typeof ident !== "string") {
					return "";
				}
				const parts = ident.split("_");
				return parts
					.map((p, i) => (i === 0 ? p : p.charAt(0).toUpperCase() + p.slice(1)))
					.join("");
			},
			isSwitchIdent(ident) {
				return typeof ident === "string" && ident.indexOf("is_") === 0;
			},
			switchRadioOptions(item) {
				const raw = item.v != null && item.v !== "" ? String(item.v).trim() : "";
				if (raw === "1" || raw === "0") {
					return [
						{ label: "是", value: "1" },
						{ label: "否", value: "0" }
					];
				}
				return [
					{ label: "是", value: "Y" },
					{ label: "否", value: "N" }
				];
			},
			fieldInitialValue(item) {
				let raw;
				if (item.v !== undefined && item.v !== null && item.v !== "") {
					raw = String(item.v).trim();
				} else if (item.displayV !== undefined && item.displayV !== null && item.displayV !== "") {
					raw = String(item.displayV).trim();
				} else {
					return "";
				}
				if (this.isSwitchIdent(item.ident)) {
					const upper = raw.toUpperCase();
					if (upper === "Y" || upper === "N") {
						return upper;
					}
					if (raw === "1" || raw === "0") {
						return raw;
					}
					return raw;
				}
				return raw;
			},
			rulesFor(item) {
				const required = {
					required: true,
					message: "必填，不能为空",
					trigger: "blur"
				};
				if (item.inputType === "price") {
					return [required, { validator: this.price, trigger: "blur" }];
				}
				return [required];
			},
			fetchData() {
				this.loading = true;
				configList()
					.then((res) => {
						this.configList = res.data.recordList || [];
						this.formKey += 1;
						const vals = {};
						this.configList.forEach((row) => {
							const key = this.fieldKey(row.ident);
							vals[key] = this.fieldInitialValue(row);
						});
						this.formModel = vals;
						this.$nextTick(() => {
							if (this.$refs.adminForm) {
								this.$refs.adminForm.clearValidate();
							}
						});
					})
					.finally(() => {
						this.loading = false;
					});
			},
			handleSubmit() {
				this.$refs.adminForm.validate((valid) => {
					if (!valid) {
						return;
					}
					configUpdate({ ...this.formModel }).then(() => {
						this.fetchData();
						this.$message.success("修改系统配置成功");
					});
				});
			},
			price(rule, value, callback) {
				if (value === undefined || value === null || value === "") {
					callback();
					return;
				}
				if (!/(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/.test(String(value))) {
					callback(new Error("请输入正确的价格"));
				} else {
					callback();
				}
			}
		}
	};
</script>

<style lang="less" scoped>
	.depict {
		width: 540px;
		margin-top: 5px;
		line-height: 150%;
		font-size: 12px;
		color: #acacac;
	}
</style>
